import styled from '@emotion/styled'
import { LazyLoadingRule } from '@pubstack/common/src/adm/rules'
import type { AdUnit } from '@pubstack/common/src/adunit'
import { CurrencySymbol } from '@pubstack/common/src/currency'
import type { DisplayedBidder, DisplayedFloorRule, DisplayedHeaderBiddingRule } from '@pubstack/common/src/stack'
import { Colors } from '~/assets/style/colors'
import { Icon } from '~/components/Icon'
import { Tooltip } from '~/components/Tooltip'
import { RichDetails } from '~/modules/adm/inventory/sites/stack/components/RichDetails'
import type { WithClassName } from '~/types/utils'

const OutOfSyncWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${Colors.Warning};
`
const Disabled = styled.span`
  font-style: italic;
  color: ${Colors.Ash};
`

type OutOfSyncProps = WithClassName & {
  name: string
  adUnit?: AdUnit
  bidder?: DisplayedBidder
  lazyLoadingRule?: LazyLoadingRule
  currencySymbol?: CurrencySymbol
  floorRule?: DisplayedFloorRule
  bidderRule?: DisplayedHeaderBiddingRule
  differences?: string[]
}

const BaseOutOfSync = ({ className, name, adUnit, bidder, lazyLoadingRule, currencySymbol, floorRule, bidderRule, differences }: OutOfSyncProps) => {
  const changes = differences ?? []
  const isDisabled = changes.some((el) => el.startsWith('ad unit'))

  return changes.length > 0 ? (
    <OutOfSyncWrapper className={className}>
      <Icon width={'18px'} name={'sync_problem'} fill={Colors.Warning} />
      <Tooltip
        reposition
        title={
          <RichDetails
            adUnit={adUnit}
            bidder={bidder}
            lazyLoadingRule={lazyLoadingRule}
            differences={changes}
            name={name}
            isDisabled={isDisabled}
            floorRule={floorRule}
            bidderRule={bidderRule}
            currencySymbol={currencySymbol}
          />
        }
      >
        {isDisabled ? <Disabled>{name}</Disabled> : <span>{name}</span>}
      </Tooltip>
    </OutOfSyncWrapper>
  ) : (
    <Tooltip
      reposition
      title={
        <RichDetails
          adUnit={adUnit}
          bidder={bidder}
          lazyLoadingRule={lazyLoadingRule}
          name={name}
          isDisabled={isDisabled}
          floorRule={floorRule}
          bidderRule={bidderRule}
          currencySymbol={currencySymbol}
        />
      }
    >
      <span className={className}>{name}</span>
    </Tooltip>
  )
}

export const OutOfSync = styled(BaseOutOfSync)``
